import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { TestSaveConstant } from 'src/app/constants/message-constant';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-save-test-dialog',
  templateUrl: './save-test-dialog.component.html',
  styleUrls: ['./save-test-dialog.component.scss']
})
export class SaveTestDialogComponent implements OnInit {
  errorMessage: any = [];
  saveTestObj: any;
  Name: string = '';
  testConstant: any;
  ConfirmMessage: any;
  TestId: any;
  SaveTest: any;

  constructor(public modalService: NgbActiveModal, private common: CommonService) { this.common.isSystemAlert = true; }

  ngOnInit(): void {
    this.testConstant = TestSaveConstant;
    this.errorMessage = commonErrorMessage;
    this.TestId = this.saveTestObj.testId;
    if (this.TestId > 0) {
      this.ConfirmMessage = this.testConstant.EditTestConfirm;
      this.SaveTest = 'Update Exam';
    }
    else {
      this.ConfirmMessage = this.testConstant.CONFIRM;
      this.SaveTest = 'Save Exam';
    }
    if (this.saveTestObj) {
      this.Name = this.saveTestObj.testName
    }
  }
}
